module.exports = __webpack_public_path__ + "static/media/jori-routo.2c74e138.jpg";